import { Handle, type HandleProps } from '@xyflow/react';

const FlowCardHandle = (props: HandleProps) => {
	return (
		<Handle
			{...props}
			style={{
				background: 'white',
				width: 16,
				height: 16,
				borderRadius: '50%',
				border: '1px solid var(--type-color)',
				position: 'static',
				top: 0,
				left: 0,
				transform: 'none'
			}}
		/>
	);
};

export default FlowCardHandle;
